module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/datagrid/datagrid-table/datagrid-table.component.scss
// module id = ./libs/atenea-cms/src/datagrid/datagrid-table/datagrid-table.component.scss
// module chunks = main